import { all, call, fork, put, takeEvery } from 'redux-saga/effects'
import { showLoading, hideLoading } from 'react-redux-loading-bar'
import { notify } from 'reapop'
import SubscriptionsService from '../middlewares/subscriptions'
import {
  GET_PLANS_REQUEST,
  GET_PLANS,
  CREATE_PLAN_REQUEST,
  GET_SUBSCRIPTIONS_REQUEST,
  GET_SUBSCRIPTIONS,
  GET_SUBSCRIPTION_REQUEST,
  GET_SUBSCRIPTION,
  CREATE_SUBSCRIPTION_REQUEST,
  CREATE_PLAN,
  CREATE_SUBSCRIPTION,
  UPDATE_SUBSCRIPTION_REQUEST,
  UPDATE_SUBSCRIPTION,
  UPDATE_PLAN_REQUEST,
  UPDATE_PLAN,
  GET_SUBSCRIPTIONS_REQUEST_PENDING,
  GET_SUBSCRIPTIONS_REQUEST_SUCCESS,
  GET_SUBSCRIPTIONS_REQUEST_ERROR,
  CHANGE_SUBSCRIPTIONS_REQUEST_PENDING,
  CHANGE_SUBSCRIPTIONS_REQUEST_SUCCESS,
  CHANGE_SUBSCRIPTIONS_REQUEST_ERROR,
  GET_CUSTOMER_SUBSCRIPTIONS_REQUEST,
  GET_CUSTOMER_SUBSCRIPTIONS,
  GET_CUSTOMER_SUBSCRIPTIONS_REQUEST_PENDING,
  GET_CUSTOMER_SUBSCRIPTIONS_REQUEST_SUCCESS,
  GET_CUSTOMER_SUBSCRIPTIONS_REQUEST_ERROR,
} from '../types/subscriptions'

function* getPlansWatcher() {
  yield takeEvery(GET_PLANS_REQUEST, getPlansWorker)
}

function* getSubscriptionsWatcher() {
  yield takeEvery(GET_SUBSCRIPTIONS_REQUEST, getSubscriptionsWorker)
}

function* getSubscriptionWatcher() {
  yield takeEvery(GET_SUBSCRIPTION_REQUEST, getSubscriptionWorker)
}

function* createPlanWatcher() {
  yield takeEvery(CREATE_PLAN_REQUEST, createPlanWorker)
}

function* updatePlanWatcher() {
  yield takeEvery(UPDATE_PLAN_REQUEST, updatePlanWorker)
}

function* createSubscriptionWatcher() {
  yield takeEvery(CREATE_SUBSCRIPTION_REQUEST, createSubscriptionWorker)
}

function* updateSubscriptionWatcher() {
  yield takeEvery(UPDATE_SUBSCRIPTION_REQUEST, updateSubscriptionWorker)
}

function* getCustomerSubscriptionsWatcher() {
  yield takeEvery(GET_CUSTOMER_SUBSCRIPTIONS_REQUEST, getCustomerSubscriptionsWorker)
}

function* getPlansWorker() {
  try {
    yield put(showLoading())
    yield put({ type: GET_SUBSCRIPTIONS_REQUEST_PENDING })
    const response = yield call(SubscriptionsService.getPlans)
    yield put({ type: GET_PLANS, payload: response.data.data || response.data })
    yield put({ type: GET_SUBSCRIPTIONS_REQUEST_SUCCESS })
    yield put(hideLoading())
  } catch (error) {
    const errors = error?.response?.data?.messages || []
    yield put({ type: GET_SUBSCRIPTIONS_REQUEST_ERROR, payload: errors })
    yield put(hideLoading())
  }
}

function* updatePlanWorker({ payload: { id, data } }) {
  try {
    yield put({ type: CHANGE_SUBSCRIPTIONS_REQUEST_PENDING })
    yield call(SubscriptionsService.updatePlan, id, data)
    yield put({ type: UPDATE_PLAN, payload: { id, data } })
    yield put({ type: CHANGE_SUBSCRIPTIONS_REQUEST_SUCCESS })
    yield put(notify({ status: 'success', title: 'Plan updated', dismissAfter: 4000 }))
    yield call(getPlansWorker)
  } catch (error) {
    const errors = error?.response?.data?.messages || []
    yield put({ type: CHANGE_SUBSCRIPTIONS_REQUEST_ERROR, payload: errors })
    yield put(
      notify({ status: 'error', title: errors?.[0]?.message || 'Plan update failed', dismissAfter: 5000 }),
    )
  } finally {
    yield put(hideLoading())
  }
}

function* getSubscriptionsWorker() {
  try {
    yield put(showLoading())
    yield put({ type: GET_SUBSCRIPTIONS_REQUEST_PENDING })
    const response = yield call(SubscriptionsService.getSubscriptions)
    yield put({ type: GET_SUBSCRIPTIONS, payload: response.data.data || response.data })
    yield put({ type: GET_SUBSCRIPTIONS_REQUEST_SUCCESS })
    yield put(hideLoading())
  } catch (error) {
    const errors = error?.response?.data?.messages || []
    yield put({ type: GET_SUBSCRIPTIONS_REQUEST_ERROR, payload: errors })
    yield put(hideLoading())
  }
}

function* getSubscriptionWorker({ payload: { id } }) {
  try {
    yield put(showLoading())
    yield put({ type: GET_SUBSCRIPTIONS_REQUEST_PENDING })
    const response = yield call(SubscriptionsService.getSubscriptionById, id)
    yield put({ type: GET_SUBSCRIPTION, payload: response.data.data || response.data })
    yield put({ type: GET_SUBSCRIPTIONS_REQUEST_SUCCESS })
    yield put(hideLoading())
  } catch (error) {
    const errors = error?.response?.data?.messages || []
    yield put({ type: GET_SUBSCRIPTIONS_REQUEST_ERROR, payload: errors })
    yield put(hideLoading())
  }
}

function* createPlanWorker({ payload }) {
  try {
    yield put({ type: CHANGE_SUBSCRIPTIONS_REQUEST_PENDING })
    yield call(SubscriptionsService.createPlan, payload)
    yield put({ type: CREATE_PLAN, payload })
    yield put({ type: CHANGE_SUBSCRIPTIONS_REQUEST_SUCCESS })
    yield put(notify({ status: 'success', title: 'Plan created', dismissAfter: 4000 }))
    yield call(getPlansWorker)
  } catch (error) {
    const errors = error?.response?.data?.messages || []
    yield put({ type: CHANGE_SUBSCRIPTIONS_REQUEST_ERROR, payload: errors })
    yield put(
      notify({ status: 'error', title: errors?.[0]?.message || 'Plan create failed', dismissAfter: 5000 }),
    )
  } finally {
    yield put(hideLoading())
  }
}

function* createSubscriptionWorker({ payload }) {
  try {
    yield put({ type: CHANGE_SUBSCRIPTIONS_REQUEST_PENDING })
    yield call(SubscriptionsService.createSubscription, payload)
    yield put({ type: CREATE_SUBSCRIPTION, payload })
    yield put({ type: CHANGE_SUBSCRIPTIONS_REQUEST_SUCCESS })
    yield put(notify({ status: 'success', title: 'Subscription created', dismissAfter: 4000 }))
    yield call(getSubscriptionsWorker)
  } catch (error) {
    const errors = error?.response?.data?.messages || []
    yield put({ type: CHANGE_SUBSCRIPTIONS_REQUEST_ERROR, payload: errors })
    yield put(
      notify({
        status: 'error',
        title: errors?.[0]?.message || 'Subscription create failed',
        dismissAfter: 5000,
      }),
    )
  } finally {
    yield put(hideLoading())
  }
}

function* updateSubscriptionWorker({ payload: { id, data } }) {
  try {
    yield put({ type: CHANGE_SUBSCRIPTIONS_REQUEST_PENDING })
    yield call(SubscriptionsService.updateSubscription, id, data)
    yield put({ type: UPDATE_SUBSCRIPTION, payload: { id, data } })
    yield put({ type: CHANGE_SUBSCRIPTIONS_REQUEST_SUCCESS })
    yield put(notify({ status: 'success', title: 'Subscription updated', dismissAfter: 4000 }))
    yield call(getSubscriptionsWorker)
  } catch (error) {
    const errors = error?.response?.data?.messages || []
    yield put({ type: CHANGE_SUBSCRIPTIONS_REQUEST_ERROR, payload: errors })
    yield put(
      notify({
        status: 'error',
        title: errors?.[0]?.message || 'Subscription update failed',
        dismissAfter: 5000,
      }),
    )
  } finally {
    yield put(hideLoading())
  }
}

function* getCustomerSubscriptionsWorker({ payload }) {
  try {
    yield put(showLoading())
    yield put({ type: GET_CUSTOMER_SUBSCRIPTIONS_REQUEST_PENDING })
    const response = yield call(SubscriptionsService.getCustomerSubscriptions, payload)
    const data = response.data.data || response.data
    yield put({ type: GET_CUSTOMER_SUBSCRIPTIONS, payload: data })
    yield put({ type: GET_CUSTOMER_SUBSCRIPTIONS_REQUEST_SUCCESS })
    yield put(hideLoading())
  } catch (error) {
    const errors = error?.response?.data?.messages || []
    yield put({ type: GET_CUSTOMER_SUBSCRIPTIONS_REQUEST_ERROR, payload: errors })
    yield put(hideLoading())
  }
}

export default function* subscriptions() {
  yield all([
    fork(getPlansWatcher),
    fork(getSubscriptionsWatcher),
    fork(getSubscriptionWatcher),
    fork(createPlanWatcher),
    fork(updatePlanWatcher),
    fork(createSubscriptionWatcher),
    fork(updateSubscriptionWatcher),
    fork(getCustomerSubscriptionsWatcher),
  ])
}
